import './module/_chart.js'

window.setGraph = function () {
  /* global graphData */
  const graphList = document.querySelectorAll('.js-graph')
  if (!graphList[0]) {
    return
  }

  if (!graphData) {
    return
  }

  for (const graph of graphList) {
    const graphName = graph.dataset.graph

    new Chart(graph, graphData[graphName])
  }
}

window.setGraph() // グラフのレンダリング
